import React, { Component, Fragment } from "react";
import Header from "../Header";
import SideMenu from "../SideMenu";
import Body from "../Body";
// import Footer from "../Footer/Footer";
import {
  updateAdmin,
  deleteAdmin,
  getAllAdmin
} from "../../actions/authActions";
import { connect } from "react-redux";
import Table from "../common/Table";
import ViewAdmin from "./ViewAdmin";
import Search from "../common/Search";
import EditAdmin from "./EditAdmin";
import AddAdmin from "./AddAdmin";
import Spinner from "../common/Spinner";

export class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowViewUser: false,
      isShowEditUser: false,
      isShowAddUser: false,
      selectUser: {},
      filteredData: [],
      searchInput: ""
    };
  }

  componentDidMount() {
    this.props.getAllAdmin();
  }

  handleCancelViewUser = () => {
    this.setState({ isShowViewUser: false, selectUser: {} });
  };

  handleViewClick = id => {
    const { admins } = this.props.auth;
    let selectUser = admins.find(user => user.id === id);
    this.setState({ isShowViewUser: true, selectUser });
  };

  handleCancelEditUser = () => {
    this.setState({ isShowEditUser: false, selectUser: {} });
  };

  handleEditClick = id => {
    const { admins } = this.props.auth;
    let selectUser = admins.find(user => user.id === id);
    this.setState({ isShowEditUser: true, selectUser });
  };

  handleActiveClick = id => {
    const { admins } = this.props.auth;
    let selectUser = admins.find(user => user.id === id);
    let is_active = selectUser.is_active ? 0 : 1;
    this.props.updateAdmin({ is_active }, id);
  };

  handleDeleteClick = id => {
    this.props.deleteAdmin(id);
  };

  handleSetData = (data, searchInput) => {
    this.setState({ filteredData: data, searchInput });
  };

  handleCancelAddUser = () => {
    this.setState({ isShowAddUser: false });
  };

  handleAddClick = () => {
    this.setState({ isShowAddUser: true });
  };

  render() {
    const {
      isShowViewUser,
      selectUser,
      isShowEditUser,
      filteredData,
      searchInput,
      isShowAddUser
    } = this.state;
    const { admins } = this.props.auth;
    let headerStyle = {
      height: 45,
      paddingTop: 15,
      fontWeight: "bold"
    };
    const columns = [
      {
        Header: "S.No",
        id: "row",
        maxWidth: 75,
        headerStyle: headerStyle,
        filterable: false,
        Cell: row => {
          return <div>{row.index + 1}</div>;
        }
      },
      {
        Header: "User Id",
        accessor: "id",
        maxWidth: 120,
        headerStyle: headerStyle
      },
      {
        Header: "Name",
        accessor: "name",
        headerStyle: headerStyle
      },
      {
        Header: "Email",
        accessor: "email",
        maxWidth: 200,
        headerStyle: headerStyle
      },
      /*       {
        Header: "City",
        accessor: "attachment.class",
        headerStyle: headerStyle
      }, */
      {
        Header: "Action",
        headerStyle: headerStyle,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              textAlign: "center"
            }
          };
        },
        Cell: props => (
          <Fragment>
            <button
              type="button"
              className="btn btn-info"
              data-toggle="modal"
              data-target="#modal-default"
              title="View"
              style={{ marginLeft: "10px" }}
              onClick={id => this.handleViewClick(props.row.id)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="Edit"
              style={{ marginLeft: "10px" }}
              onClick={id => this.handleEditClick(props.row.id)}
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </button>
            {props.row._original.is_active ? (
              <button
                type="button"
                className="btn btn-warning"
                data-toggle="tooltip"
                title="Status"
                style={{ marginLeft: "10px" }}
                onClick={id => this.handleActiveClick(props.row.id)}
              >
                <i className="fa fa-check" aria-hidden="true"></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-status"
                data-toggle="tooltip"
                title="Status"
                style={{ marginLeft: "10px" }}
                onClick={id => this.handleActiveClick(props.row.id)}
              >
                <i className="fa fa-close" aria-hidden="true"></i>
              </button>
            )}
            <button
              type="button"
              className="btn btn-danger"
              data-toggle="tooltip"
              title="Delete"
              style={{ marginLeft: "10px" }}
              onClick={id => this.handleDeleteClick(props.row.id)}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </button>
          </Fragment>
        ) // Custom cell components!
      }
    ];

    const fields = ["name", "email"];

    return (
      <div className="skin-blue ">
        <div className="wrapper">
          <Header />
          <SideMenu active="admin" />
          <Body>
            <section className="content-header">
              <h1>Admins</h1>
              <ol className="breadcrumb">
                <li>
                  <a /* href="#" */>
                    <i className="fa fa-dashboard"></i> Home
                  </a>
                </li>
                <li className="active">Admins</li>
              </ol>
            </section>

            {admins.length > 0 ? (
              <section className="content">
                <div className="row">
                  <div className="col-xs-12">
                    <div
                      className="pull-right"
                      style={{ marginBottom: "10px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-success"
                        data-toggle="tooltip"
                        title="Add"
                        style={{ marginRight: "10px" }}
                        onClick={this.handleAddClick}
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>
                      </button>
                      <Search
                        data={admins}
                        handleSetData={this.handleSetData}
                        fields={fields}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="box">
                      <div className="box-body">
                        <Table
                          data={
                            filteredData.length > 0
                              ? filteredData
                              : searchInput
                              ? filteredData
                              : admins
                          }
                          columns={columns}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <Spinner />
            )}
            {isShowViewUser ? (
              <ViewAdmin
                handleCancelViewUser={this.handleCancelViewUser}
                user={selectUser}
              />
            ) : null}
            {isShowEditUser ? (
              <EditAdmin
                handleCancelEditUser={this.handleCancelEditUser}
                user={selectUser}
              />
            ) : null}
            {isShowAddUser ? (
              <AddAdmin handleCancelAddUser={this.handleCancelAddUser} />
            ) : null}
          </Body>
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, {
  getAllAdmin,
  updateAdmin,
  deleteAdmin
})(User);



// WEBPACK FOOTER //
// ./src/components/Admin/index.js